/* eslint-disable no-undef */
import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import yaml from 'js-yaml';

const resources = {};
Object.keys(CURRENT_TRANSLATIONS).forEach(key => {
  resources[key] = {
    translation: CURRENT_TRANSLATIONS[key]
  };
});

i18n
  // .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    lng: 'en',
    resources,
    // backend: {
    //   loadPath: '/config/locales/{{lng}}.yml',
    //   parse: (data) => {
    //     console.log(data);
    //     return yaml.load(data);
    //   },
    //   requestOptions: {
    //     mode: 'cors',
    //     credentials: 'same-origin',
    //     cache: 'default'
    //   }
    // }
    interpolation: {
      prefix: '%{',
      suffix: '}',
    }
  });

export const translate = (key, options) => {
  const franchise = FRANCHISE_CODE.toLowerCase();
  const scopedOptions = {
    ...(options || {}),
    scope: franchise,
    defaultValue: i18n.t(key, options)
  };
  return i18n.t(key, scopedOptions);
};

export default i18n;
